import React from 'react';
import PropTypes from 'prop-types'


const Icon = ({ iconName }) => {
    return (
        <span className={`dx-icon-${iconName}`}></span>
    );
}

Icon.propTypes = {
    iconName: PropTypes.string
};

export default Icon;
